





















import { defineComponent, ref } from '@nuxtjs/composition-api'

// Components
import ImageEnhancementHeader from '~/components/feature/image-enhancement/Header.vue'
import ImageEnhancementImageSlider from '@/components/feature/image-enhancement/Slider.vue'
import ImageEnhancementFooter from '~/components/feature/image-enhancement/Footer.vue'
import ImageEnhancementError from '~/components/feature/image-enhancement/Error.vue'

// Types
import { ImageEnhancementConfigInterface } from '~/types/image-enhancement/imageEnhancementTypes'

export default defineComponent({
  name: 'ImageEnhancementViewer',

  components: {
    ImageEnhancementHeader,
    ImageEnhancementImageSlider,
    ImageEnhancementFooter,
    ImageEnhancementError,
  },

  props: {
    config: {
      type: Object as () => ImageEnhancementConfigInterface,
      required: true,
    },
  },

  emits: [
    'imageEnhancementCarousselPrev',
    'imageEnhancementCarousselNext',
    'onChangeSlider',
    'onImageEnhancementChangeApplication',
  ],

  setup() {
    const caroussel = ref(null)
    const imageEnhancementImageSlider: any = ref(null)

    return {
      imageEnhancementImageSlider,
      caroussel,
    }
  },
})
